import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { reviewBroadcast } from 'api/broadcasts.service';
import { useToast } from 'hooks/ui';
import { setDraftBroadcast } from 'store/broadcast';
import { useApplicationStore } from 'store/application';
import { broadcastKeys } from './queryKeys';

export const useBroadcastReviewQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { mutate, isPending } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return reviewBroadcast(id);
    },
    onSuccess: (broadcast) => {
      toast.success('Broadcast has been sent for review successfully');
      setDraftBroadcast(broadcast);
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: broadcastKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
